/* Spartan TR — ürün detay sekmeleri, abonelik toggle, sticky bar */
document.addEventListener('click', function(e){
  var t = e.target.closest('.pd-tab');
  if(t){
    var w = t.closest('.pd-wrap');
    w.querySelectorAll('.pd-tab').forEach(function(x){x.classList.remove('on')});
    w.querySelectorAll('.pd-pane').forEach(function(x){x.classList.remove('on')});
    t.classList.add('on');
    var pane = w.querySelector('#'+t.dataset.pd);
    if(pane) pane.classList.add('on');
  }
  var b = e.target.closest('.subtoggle button');
  if(b){
    b.parentElement.querySelectorAll('button').forEach(function(x){x.classList.remove('on')});
    b.classList.add('on');
  }
});
function spSticky(){
  var s = document.getElementById('sticky');
  if(s) s.classList.toggle('show', window.scrollY > 700);
}
window.addEventListener('scroll', spSticky, {passive:true});
window.addEventListener('load', spSticky);
if(document.readyState !== 'loading'){ spSticky(); } else { document.addEventListener('DOMContentLoaded', spSticky); }
/* COD formu acilinca musterinin sectigi paketi (ilk kademe = 1 adet) secili getir.
   Uygulama varsayilan olarak en ust kademeyi (3 Al 2 Ode) secili getiriyordu; tiklanan pakete uymuyordu. */
function spCodPickFirst(tries){
  tries = tries || 0;
  var b = document.querySelector('.sf-cod__bundle');
  if(b){
    if(b.className.indexOf('--active') < 0) b.click();
    return;
  }
  if(tries < 20) setTimeout(function(){ spCodPickFirst(tries+1); }, 200);
}
document.addEventListener('click', function(e){
  if(e.target.closest && e.target.closest('.sf-cod__trigger')) setTimeout(function(){ spCodPickFirst(0); }, 350);
});
/* ?cod=1 ile gelindiginde kapida odeme formunu otomatik ac (app blogu gec yuklenebilir) */
(function(){
  if(location.search.indexOf('cod=1') < 0) return;
  var tries = 0;
  var iv = setInterval(function(){
    tries++;
    var t = document.querySelector('.sf-cod__trigger');
    if(t){ clearInterval(iv); setTimeout(function(){ t.click(); spCodPickFirst(0); }, 250); }
    else if(tries > 40){ clearInterval(iv); }
  }, 250);
})();
/* sticky CTA: yumusak kaydirma + sabit baslik payi */
document.addEventListener('click', function(e){
  var a = e.target.closest('#sticky a, .sticky a');
  if(!a) return;
  var href = a.getAttribute('href') || '';
  if(href.charAt(0) !== '#' || href.length < 2) return;
  var t = document.querySelector(href);
  if(!t) return;
  e.preventDefault();
  var y = t.getBoundingClientRect().top + window.scrollY - 12;
  window.scrollTo({top: y < 0 ? 0 : y, behavior: 'smooth'});
  if(history.replaceState) history.replaceState(null, '', href);
});
